<template>
  <v-col cols="12" v-if="permisoVista('simulacion', 'r')">
    <v-dialog v-model="dialog" persistent max-width="60%">
      <v-card>
        <v-card-title>
          {{
            editedItem.area
              ? `Editar Configuración (Moldes) del Área de ${editedItem.area}`
              : "Crear Nueva Configuración (Moldes)"
          }}
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" v-if="!editedItem.area">
                <v-autocomplete
                  v-model="editedItem.idArea"
                  label="Área"
                  :items="areas"
                  item-text="nombre"
                  item-value="idArea"
                  clearable
                  :error-messages="errorArea"
                  @focus="errorArea = ''"
                  @change="areaChanged"
                />
              </v-col>

              <v-col cols="12">
                <v-data-table
                  :items="editedItem.lineas"
                  :headers="lineasHeaders"
                  hide-default-footer
                  :items-per-page="-1"
                >
                  <template v-slot:[`item.nombre`]="{ item }">
                    <v-text-field
                      v-model="item.nombre"
                      dense
                      clearable
                      :error-messages="item.errorNombre"
                      @focus="item.errorNombre = ''"
                    />
                  </template>

                  <template v-slot:[`item.numOperadores`]="{ item }">
                    <number-input
                      v-model="item.numOperadores"
                      controls
                      inline
                      size="small"
                      :min="0"
                      center
                      @change="item.errorNumOperador = ''"
                    />
                    <v-scroll-y-transition>
                      <p
                        v-if="item.errorNumOperador"
                        class="mb-0 red--text"
                        style="font-size: 12px !important"
                      >
                        {{ item.errorNumOperador }}
                      </p>
                    </v-scroll-y-transition>
                  </template>

                  <template v-slot:[`item.idsMoldes`]="{ item, index }">
                    <v-autocomplete
                      v-model="item.idsMoldes"
                      :items="moldesLineas(index)"
                      :item-text="nombreMolde"
                      item-value="idMolde"
                      multiple
                      chips
                      deletable-chips
                      clearable
                      :disabled="loadingMoldes"
                      :loading="loadingMoldes"
                      :error-messages="item.errorMoldes"
                      @focus="item.errorMoldes = ''"
                    />
                  </template>

                  <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip
                      v-if="permisoVista('simulacion', 'u')"
                      bottom
                      color="black"
                      class="white--text"
                    >
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" small class="mr-2" @click="eliminarLinea(item)">
                          delete
                        </v-icon>
                      </template>
                      <span class="white--text">Eliminar</span>
                    </v-tooltip>
                  </template>
                </v-data-table>

                <v-btn text color="primary" @click="agregarLinea">
                  <v-icon left>mdi-plus</v-icon>
                  Agregar línea
                </v-btn>

                <v-scroll-y-transition>
                  <p
                    v-if="errorNoLineas"
                    class="mb-0 mt-1 red--text"
                    style="font-size: 12px !important"
                  >
                    {{ errorNoLineas }}
                  </p>
                </v-scroll-y-transition>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text color="success" :disabled="saving" @click="cerrarDialog">Cancelar</v-btn>
          <v-btn text color="error" :disabled="saving" :loading="saving" @click="save">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row v-if="permisoVista('simulacion', 'c')">
      <v-col cols="4" class="py-0">
        <v-btn color="primary" :disabled="loading" @click="showDialog">
          Crear Nueva Configuración (Moldes)
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :items="simulacion"
          :headers="simulacionHeaders"
          :loading="loading"
        >
          <template v-slot:[`header.lineas`]>
            <div class="d-flex">
              <div class="d-flex justify-center align-center" style="width: 10%;font-size: 1.0625rem !important;">
                # de Operadores
              </div>
              <div class="d-flex justify-center align-center" style="width: 30%;font-size: 1.0625rem !important;">
                Línea
              </div>
              <div class="d-flex justify-center align-center" style="width: 60%;font-size: 1.0625rem !important;">
                Moldes Disponibles
              </div>
            </div>
          </template>

          <template v-slot:[`item.lineas`]="{ item, index }">
            <v-simple-table class="transparent my-1">
              <template v-slot:default>
                <tbody>
                  <tr
                    v-for="linea in item.lineas"
                    :key="`tr-linea-moldes-${linea.idConfiguracionArea}-${linea.nombre}`"
                    class="transparent"
                  >
                    <td class="text-center" width="10%">{{ linea.numOperadores }}</td>
                    <td class="text-center" width="30%">{{ linea.nombre }}</td>
                    <td class="text-center py-2" width="60%">
                      <p
                        v-if="lineaIdsMoldes(linea).length === 0"
                        class="mb-0 py-1"
                        :key="`linea-nomoldes-${index}`"
                      >
                        N/A
                      </p>
                      <template v-else>
                        <p
                          v-for="idMolde in lineaIdsMoldes(linea)"
                          class="mb-0 py-1"
                          :key="`molde-${linea.idConfiguracionArea}-${idMolde}`"
                        >
                          • {{ getNombreMoldeById(idMolde) }}
                        </p>
                      </template>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip
              v-if="permisoVista('simulacion', 'u')"
              bottom
              color="black"
              class="white--text"
            >
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" small class="mr-2" @click="showDialog(item)">
                  edit
                </v-icon>
              </template>
              <span class="white--text">Editar</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      loadingMoldes: false,
      moldes: [],
      areas: [],
      errorNoLineas: "",
      errorArea: "",
      saving: false,
      loading: false,
      lineasHeaders: [
        { text: "Nombre línea", align: "center", sortable: false, value: "nombre" },
        { text: "# Operadores", align: "center", width: "10%", sortable: false, value: "numOperadores" },
        { text: "Moldes", align: "center", sortable: false, value: "idsMoldes" },
        { text: "Acciones", align: "center", width: "10%", sortable: false, value: "actions" }
      ],
      simulacionHeaders: [
        { text: "Área", align: "center", width: "15%", value: "area" },
        { text: "Lineas", align: "center", sortable: false, value: "lineas" },
        { text: "Acciones", align: "center", width: "10%", sortable: false, value: "actions" }
      ],
      simulacion: [],
      dialog: false,
      defaultItemLinea: {
        idConfiguracionArea: null,
        nombre: null,
        idsMoldes: [],
        numOperadores: 0,
        errorNombre: "",
        errorNumOperador: "",
        errorMoldes: ""
      },
      editedItem: {
        idArea: null,
        area: null,
        lineas: []
      },
      defaultEditedItem: {
        idArea: null,
        area: null,
        lineas: []
      }
    };
  },
  mounted() {
    this.initialize();
  },
  methods: {
    lineaIdsMoldes(linea) {
      if (!linea) return [];
      if (Array.isArray(linea.idsMoldes)) return linea.idsMoldes;
      return [];
    },
    getNombreMoldeById(idMolde) {
      const molde = this.moldes.find(m => Number(m.idMolde) === Number(idMolde));
      if (!molde) return `Molde ${idMolde}`;
      const codigo = molde.codigo ? `[${molde.codigo}]` : "";
      const nombre = molde.nombre ? ` - ${molde.nombre}` : "";
      return `${codigo}${nombre}`.trim() || `Molde ${idMolde}`;
    },
    nombreMolde(molde) {
      if (!molde) return "";
      const codigo = molde.codigo ? `[${molde.codigo}]` : "";
      const nombre = molde.nombre ? ` - ${molde.nombre}` : "";
      return `${codigo}${nombre}`.trim();
    },
    moldesLineas(index, bypass) {
      const moldesSeleccionados = [];
      this.editedItem.lineas.forEach((linea, idx) => {
        const ids = Array.isArray(linea.idsMoldes) ? linea.idsMoldes : [];
        if (bypass) {
          moldesSeleccionados.push(...ids);
        } else if (idx !== index) {
          moldesSeleccionados.push(...ids);
        }
      });

      return this.moldes.filter(molde => !moldesSeleccionados.includes(molde.idMolde));
    },
    areaChanged() {
      this.editedItem.lineas.forEach((linea) => {
        this.$set(linea, "idsMoldes", []);
      });
    },
    eliminarLinea(item) {
      const index = this.editedItem.lineas.indexOf(item);
      this.editedItem.lineas.splice(index, 1);
    },
    agregarLinea() {
      this.editedItem.lineas.push(JSON.parse(JSON.stringify(this.defaultItemLinea)));
      this.errorNoLineas = "";
    },
    cerrarDialog() {
      this.dialog = false;
      this.editedItem = JSON.parse(JSON.stringify(this.defaultEditedItem));
      this.resetErrores();
    },
    resetErrores() {
      this.errorArea = "";
      this.errorNoLineas = "";

      this.editedItem.lineas.forEach((linea) => {
        this.$set(linea, "errorNombre", "");
        this.$set(linea, "errorNumOperador", "");
        this.$set(linea, "errorMoldes", "");
      });
    },
    validate() {
      this.resetErrores();
      let erroresLineas = false;

      if (this.editedItem.idArea == null) {
        this.errorArea = "Debe seleccionar un área";
      }

      if (this.editedItem.lineas.length === 0) {
        this.errorNoLineas = "Debe agregar al menos 1 línea";
      } else {
        this.editedItem.lineas.forEach((linea) => {
          if (linea.nombre == null || String(linea.nombre).trim().length === 0) {
            this.$set(linea, "errorNombre", "Requerido");
            erroresLineas = true;
          } else if (String(linea.nombre).trim().length < 4) {
            this.$set(linea, "errorNombre", "Mínimo 4 caracteres");
            erroresLineas = true;
          }

          if (Number(linea.numOperadores) === 0) {
            this.$set(linea, "errorNumOperador", "Mínimo 1 operador");
            erroresLineas = true;
          }

          if (!Array.isArray(linea.idsMoldes) || linea.idsMoldes.length === 0) {
            this.$set(linea, "errorMoldes", "Selecciona al menos 1 molde");
            erroresLineas = true;
          }
        });
      }

      return this.errorArea === "" && this.errorNoLineas === "" && !erroresLineas;
    },
    save() {
      if (!this.validate()) return;

      const obj = {
        idArea: this.editedItem.idArea,
        lineas: this.editedItem.lineas.map((linea) => ({
          idConfiguracionArea: linea.idConfiguracionArea,
          nombre: linea.nombre,
          numOperadores: linea.numOperadores,
          idsMoldes: Array.isArray(linea.idsMoldes) ? linea.idsMoldes : []
        }))
      };

      this.saving = true;
      axios
        .post("/ConfiguracionArea/CrearNuevaConfiguracionMoldes", obj)
        .then(() => {
          this.cerrarDialog();
          this.initialize();
          this.$emit("refreshValidation");
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.saving = false;
        });
    },
    showDialog(item) {
      this.getMoldesDisponibles();

      const base = JSON.parse(JSON.stringify(item || this.defaultEditedItem));
      if (Array.isArray(base.lineas)) {
        base.lineas = base.lineas.map((linea) => ({
          ...linea,
          idsMoldes: Array.isArray(linea.idsMoldes) ? linea.idsMoldes : [],
          errorNombre: "",
          errorNumOperador: "",
          errorMoldes: ""
        }));
      } else {
        base.lineas = [];
      }

      this.editedItem = base;
      this.dialog = true;
    },
    initialize() {
      this.getAreas();
      this.getMoldes();
      this.getSimulacion();
    },
    getMoldes() {
      this.loadingMoldes = true;
      axios
        .get("/Moldes")
        .then((response) => {
          this.moldes = response.data || [];
        })
        .catch((error) => {
          this.moldes = [];
          console.log(error);
        })
        .finally(() => {
          this.loadingMoldes = false;
        });
    },
    getAreas() {
      axios
        .get("/ConfiguracionArea/AreasSinConfiguracionMoldes")
        .then((response) => {
          this.areas = (response.data || []).filter((area) => area.idArea !== 1);
        })
        .catch((error) => {
          this.areas = [];
          console.log(error);
        });
    },
    getMoldesDisponibles() {
      if (this.moldes.length > 0) return;
      this.getMoldes();
    },
    getSimulacion() {
      this.loading = true;
      axios
        .get("/ConfiguracionArea/Moldes")
        .then((response) => {
          this.simulacion = response.data || [];
        })
        .catch((error) => {
          this.simulacion = [];
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.custom-th {
  font-size: .875rem !important;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
</style>
